import http from "@/api/http";

export const fetchProfile = () => {
  return http.get("/landing/parent/profile");
};

export const fetchChildren = () => {
  return http.get("/landing/parent/students");
};

export const fetchChild = (query) => {
  const { start_date, end_date, child_id } = query;
  return http.get(
    `/landing/parent/students/${child_id}?start_date=${start_date}&end_date=${end_date}`
  );
};

export const fetchTabels = () => {
  return http.get(`/landing/parent/tabels`);
};

export const fetchActs = (params) => {
  return http.get(`/landing/parent/tabels/${params.groupId}/student/${params.childId}`);
};

export const fetchActInfo = (query) => {
  return http.get(
    `/landing/parent/tabels/${query.groupId}/student/${query.childId}/act/${query.actId}`
  );
};

export const fetchSubmitAct = (query) => {
  return http.post(
    `/landing/parent/tabels/${query.groupId}/student/${query.childId}/act/${query.actId}/agree`
  );
};

export const fetchRejectAct = (query) => {
  return http.post(
    `/landing/parent/tabels/${query.groupId}/student/${query.childId}/act/${query.actId}/reject`,
    { comment: query.comment }
  );
};

export const fetchApplications = () => {
  return http.get(`/landing/parent/applications`);
};

export const fetchApplicationInfo = (id) => {
  return http.get(`/landing/parent/applications/${id}`);
};

export const fetchExportChild = () => {
  return http.post("/landing/parent/students/update");
};

export const saveProfile = (data) => {
  return http.post("/landing/parent/profile/update", data);
};

export const fetchIssuedByData = () => {
  return http.get("/reference/issued-by");
};

export const fetchDocumentType = () => {
  return http.get("/reference/document-type");
};

export const fetchDeleteApplication = (id) => {
  return http.delete(`/landing/parent/applications/${id}/reject`);
};

export const applyCourse = (data) => {
  return http.post(`/landing/course/${data.courseId}/apply`, data);
};
